// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__hSvED","title":"card_title__cZLYQ","inActive":"card_inActive__18bSH"};